<template>
  <div class="requests">
    <Breadcrumb>
      <router-link to="/">Startseite</router-link>
      <router-link to="/buergerkonto">Bürgerkonto</router-link>
      <router-link to="/buergerkonto/aktivitaeten">Letzte Aktivitäten</router-link>
    </Breadcrumb>
    <div class="requests__header">
      <div class="headline-link wrapper">
        <div class="headline-link__headline">
          <router-link to="/buergerkonto" class="back-button"><Icon icon="arrowLeft" /></router-link>
          <Icon icon="onlineForm" color="detailed" class="hide-mobile"/>
          <Headline subline="Ihre Anträge & Anfragen" headline="Zuletzt genutzte Dienstleistungen" />
        </div>
        <div class="headline-link__right hide-mobile">
          <form @submit.prevent="filterRequests(searchTerm)" class="input-wrapper">
            <input type="search" placeholder="Aktivitäten durchsuchen..." v-model="searchTerm" @click="filterRequests(searchTerm)">
            <Icon icon="search"/>
          </form>
        </div>
      </div>
    </div>
    <div class="requests__content wrapper margin-bottom--90 margin-top--40">
      <div class="row between-xs">
        <div class="requests__content__left col-xs-12 col-md-8">
          <div v-if="requests.length < 1" class="no-requests">
            <Icon icon="onlineForm" color="detailed" />
            <div class="text">
              <h6>Keine Aktivitäten</h6>
              <p>Es befinden sich keine vergangenen Aktivitäten in Ihrem Bürgerkonto</p>
            </div>
          </div>
          <!-- Aktivitäten-Tab 1 -->
          <div v-else>
            <div class="requests-tab" v-show="activeTab == 1">
              <div class="requests-tab__header">
                <h6>Ihre Aktivitäten ({{ allRequests.length }})</h6>
              </div>
              <div class="requests-tab__content">
                <!-- Aktivität -->
                <div class="request" v-for="request in allRequests" :key="request.id" @click="showRequestModal(request.id)">
                  <div class="request__content">
                    <Icon v-if="request.online" icon="computer" />
                    <Icon v-else icon="noComputer" />
                    <div class="text">
                      <p>{{ request.name }}</p>
                      <span>Letzte Statusänderung: {{ request.date }}</span>
                    </div>
                    <span :class="{ 'wait' : request.status == 'In Bearbeitung', 'fail' : request.status == 'Abgelehnt', 'done' : request.status == 'Abgeschlossen'}">{{ request.status}}</span>
                    <Icon icon="wait" />
                  </div>
                </div>
                <Modal v-if="showModal && activeRequest" @closeModal="toggleModal" :outside="true">
                  <Card padding="35px" class="modal-new">
                    <h3>Aktivitäten-Details</h3>
                    <table>
                      <tr>
                        <td>Name:</td>
                        <td>{{ activeRequest.name }}</td>
                      </tr>
                      <tr>
                        <td>Status:</td>
                        <td>{{ activeRequest.status }}</td>
                      </tr>
                      <tr>
                        <td>Letzte Statusänderung:</td>
                        <td>{{ activeRequest.date }}</td>
                      </tr>
                    </table>
                    <Button text="Antrag öffnen" type="primary" class="margin-top--30 margin-bottom--20"/>
                  </Card>           
                </Modal>
              </div>
            </div>
            <!-- Aktivitäten-Tab 2 -->
            <div class="requests-tab" v-show="activeTab == 2">
              <div class="requests-tab__header">
                <h6>Online-Services ({{ onlineRequests.length }})</h6>
              </div>
              <div class="requests-tab__content">
                <!-- Aktivität -->
                <div class="request" v-for="request in onlineRequests" :key="request.id" @click="showRequestModal(request.id)">
                  <div class="request__content">
                    <Icon v-if="request.online" icon="computer" />
                    <Icon v-else icon="noComputer" />
                    <div class="text">
                      <p>{{ request.name }}</p>
                      <span>Letzte Statusänderung: {{ request.date }}</span>
                    </div>
                    <span :class="{ 'wait' : request.status == 'In Bearbeitung', 'fail' : request.status == 'Abgelehnt', 'done' : request.status == 'Abgeschlossen'}">{{ request.status}}</span>
                    <Icon icon="wait" />
                  </div>
                </div>
                <Modal v-if="showModal && activeRequest" @closeModal="toggleModal" :outside="true">
                  <Card padding="35px" class="modal-new">
                    <h3>Aktivitäten-Details</h3>
                    <table>
                      <tr>
                        <td>Name:</td>
                        <td>{{ activeRequest.name }}</td>
                      </tr>
                      <tr>
                        <td>Status:</td>
                        <td>{{ activeRequest.status }}</td>
                      </tr>
                      <tr>
                        <td>Letzte Statusänderung:</td>
                        <td>{{ activeRequest.date }}</td>
                      </tr>
                    </table>
                    <Button text="Antrag öffnen" type="primary" class="margin-top--30 margin-bottom--20"/>
                  </Card>           
                </Modal>
              </div>
            </div>
            <!-- Aktivitäten-Tab 3 -->
            <div class="requests-tab" v-show="activeTab == 3">
              <div class="requests-tab__header">
                <h6>Analoge Services ({{ offlineRequests.length }})</h6>
              </div>
              <div class="requests-tab__content">
                <!-- Aktivität -->
                <div class="request" v-for="request in offlineRequests" :key="request.id" @click="showRequestModal(request.id)">
                  <div class="request__content">
                    <Icon v-if="request.online" icon="computer" />
                    <Icon v-else icon="noComputer" />
                    <div class="text">
                      <p>{{ request.name }}</p>
                      <span>Letzte Statusänderung: {{ request.date }}</span>
                    </div>
                    <span :class="{ 'wait' : request.status == 'In Bearbeitung', 'fail' : request.status == 'Abgelehnt', 'done' : request.status == 'Abgeschlossen'}">{{ request.status}}</span>
                    <Icon icon="wait" />
                  </div>
                </div>
                <Modal v-if="showModal && activeRequest" @closeModal="toggleModal" :outside="true">
                  <Card padding="35px" class="modal-new">
                    <h3>Aktivitäten-Details</h3>
                    <table>
                      <tr>
                        <td>Name:</td>
                        <td>{{ activeRequest.name }}</td>
                      </tr>
                      <tr>
                        <td>Status:</td>
                        <td>{{ activeRequest.status }}</td>
                      </tr>
                      <tr>
                        <td>Letzte Statusänderung:</td>
                        <td>{{ activeRequest.date }}</td>
                      </tr>
                    </table>
                    <Button text="Antrag öffnen" type="primary" class="margin-top--30 margin-bottom--20"/>
                  </Card>           
                </Modal>
              </div>
            </div>
          </div>
        </div>

        <!-- Sidebar -->
        <div class="requests__content__sidebar col-xs-12 col-md-3">
          <div class="margin-bottom--30">
            <!-- 1 -->
            <div class="nav-element"
              @click="activeTab = 1" 
              :class="{'selected' : activeTab == 1}"
              >
              <Icon icon="recent" />
              <div class="text">
                <h6>Alle Aktivitäten</h6>
                <p>{{requests.length }} Aktivitäten</p>
              </div>
            </div>
            <!-- 2 -->
            <div class="nav-element"
              @click="activeTab = 2" 
              :class="{'selected' : activeTab == 2}"
              >
              <Icon icon="computer" />
              <div class="text">
                <h6>Online-Services</h6>
                <p>{{onlineRequests.length }} Aktivitäten</p>
              </div>
            </div>
            <!-- 3 -->
            <div class="nav-element"
              @click="activeTab = 3" 
              :class="{'selected' : activeTab == 3}"
              >
              <Icon icon="noComputer" />
              <div class="text">
                <h6>Analoge Services</h6>
                <p>{{offlineRequests.length }} Aktivitäten</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Teaser illu="messages" subline="Transparenter denn je" headline="Ihr Aktivitätenverlauf">
      <p>In Ihrer persönlichen Dokumentenbox landen nicht nur alle von Ihnen beantragten Nachweise, Zeugnisse und Bescheide, Sie können auch Ihre eigenen Datei hochladen.
        Dadurch lassen sich diese beim nächsten Online-Service ohne lästiges Suchen bequem und geräteunabhängig von überall auswählen. 
        Zeit sparen wenn es am schnellsten gehen muss!</p>
    </Teaser>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Headline from '../../components/Headline/Headline';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import Icon from '../../components/Icon/Icon';
import Card from '../../components/Card/Card';
import Toggle from '../../components/formElements/Toggle/Toggle';
import Teaser from '../../components/Teaser/Teaser';
import Button from '../../components/Button/Button';
import Modal from '../../components/Modal/Modal';
import InputText from '../../components/formElements/InputText/InputText';


export default {
  name: 'Requests',
  components: {
    Headline,
    Breadcrumb,
    Icon,
    Card,
    Toggle,
    Teaser,
    Button,
    Modal,
    InputText,
  },
  data() {
    return {
      searchTerm: '',
      showModal: false,
      toggleMessage: false,
      activeTab: 1,
      allRequests: null,
      activeRequest: null,
    };
  },
  computed: {
    ...mapGetters({
      activeUser: 'auth/getUserSession',
      requests: 'requests/getAllRequests',
      onlineRequests: 'requests/getOnlineRequests',
      offlineRequests: 'requests/getOfflineRequests',
    }),
  },
  methods: {
    filterRequests(searchTerm) {
      this.activeTab = 1;
      this.allRequests = this.requests.filter(request => request.name.toLowerCase().includes(searchTerm.toLowerCase()));
    },
    toggleModal() {
      this.showModal = !this.showModal;
    },
    toggleMessageModal() {
      this.toggleMessage = !this.toggleMessage;
    },
    showRequestModal(id) {
      this.activeRequest = this.requests.find(request => request.id == id);
      this.toggleModal();
    }
  },
  mounted() {
    this.allRequests = this.requests;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./Requests.scss" lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Requests/Requests.vue